import styled from 'styled-components'
import bgAuth from '../../assets/bgs/gid-bg.png'

export const FromCard = styled.form`
  display: flex;
  animation: identifier 2s;
  align-items: center;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 25px;
  transform-origin: center;
  border: solid 2px #a6c10b83;

  animation: expandCenter 0.9s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;

  @media (max-width: 800px) {
    padding: 0 60px;
  }
  @media (max-width: 480px) {
    padding: 0 60px;
    background: transparent;
    box-shadow: none;
  }
  .btn-text {
    color: #ffffff;
    font-size: 20px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
  }

  @keyframes expandCenter {
    from {
      opacity: 0;
      transform: scale(0.5);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
  @keyframes identifier {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .header {
    @media (max-width: 800px) {
      display: none;
    }

    font-size: 50px;
    font-weight: 500;
    font-family: 'Montserrat', sans-serif;
    font-style: italic;
    flex-direction: column;
    color: #ffffff;
    background: #02035c80;
    background-image: url(${bgAuth});
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 500px;
    height: 650px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 25px 0 0 25px;
  }

  .left {
    width: 400px;
    height: 650px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family: 'Montserrat', sans-serif;

    .left-header {
      font-size: 25px;
      font-weight: 500;
      font-family: 'Montserrat', sans-serif;
      font-style: italic;
      flex-direction: column;
      color: #ffffff;
      margin-bottom: 30px;
    }
  }

  .user {
    display: flex;
    flex-direction: column;
    gap: 5px;
    font-family: 'Montserrat', sans-serif;
    color: #ffffff;
    margin-bottom: 30px;
  }

  input {
    width: 280px;
    height: 45px;
    border-radius: 20px;
    border: none;
    padding: 0 20px;
    font-family: 'Montserrat', sans-serif;

    &:focus {
      outline: none;
    }
  }

  button {
    background: #a6c10b;
    border: none;
    width: 280px;
    height: 40px;
    justify-content: center;
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 20px;

    .btn-text {
      position: absolute;
      color: #000000;
      font-size: 20px;
      font-weight: 700;
      font-family: 'Inter', sans-serif;
    }
  }

  @keyframes logoOn {
    from {
      opacity: 0;
      transform: translateX(100px);
    }
    to {
      opacity: 1;
    }
  }

  .loading-login {
    display: flex;
    align-items: center;
    height: 80px;

    .logo {
      animation: loadingHeart infinite 1s;
      right: 20px;
      bottom: 20px;
      width: 60px;
    }
  }

  @keyframes loadingHeart {
    0% {
      opacity: 1;
      width: 62px;
    }

    100% {
      opacity: 1;
      width: 60px;
    }
  }

  .logo-footer {
    position: absolute;
    right: 20px;
    bottom: 20px;
    animation: logoOn 400ms;
    display: flex;
    align-items: center;
    gap: 5px;

    img {
      width: 60px;
    }

    span {
      color: #ffffff;
      font-size: 12px;
      font-family: 'Montserrat', sans-serif;
      font-weight: 600;
    }
  }
`
